<template>
  <div class="header-navigation">
    <div class="header-navigation__item">
      <router-link to="/vacancies" active-class="active">
        <span>{{ $tr('vacancies.title') }}</span>
      </router-link>
    </div>

    <div class="header-navigation__item">
      <router-link to="/invitations" active-class="active">
        <span>{{ $tr('invites.title') }}</span>
      </router-link>
    </div>

    <div class="header-navigation__item">
      <router-link to="/responses" active-class="active">
        <span>{{ $tr('responses.title') }}</span>
      </router-link>
    </div>

    <div class="header-navigation__item">
      <router-link to="/analytics" active-class="active" :class="{ disabled: isFeatureDisabledByTariff('analytics') }">
        <span>{{ $tr('analytics.title') }}</span>
      </router-link>

      <vcv-billing-lock v-if="isFeatureDisabledByTariff('analytics')" feature="analytics" />
    </div>

    <!-- <a
      :class="{ active: online_interview }"
      @click.prevent="
      onlineInterviewEnabled ? goToOnlineInterview() : showPopup(onlineInterviewModule, true)
      "
      >
      <span>{{ $tr('online-interview.name') }}</span>
      <div v-if="!onlineInterviewEnabled" class="vmodule-clickable">
      <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <path
      d="M9.33333 4.66667H8.66667V3.33333C8.66667 1.49333 7.17333 0 5.33333 0C3.49333 0 2 1.49333 2 3.33333V4.66667H1.33333C0.6 4.66667 0 5.26667 0 6V12.6667C0 13.4 0.6 14 1.33333 14H9.33333C10.0667 14 10.6667 13.4 10.6667 12.6667V6C10.6667 5.26667 10.0667 4.66667 9.33333 4.66667ZM5.33333 10.6667C4.6 10.6667 4 10.0667 4 9.33333C4 8.6 4.6 8 5.33333 8C6.06667 8 6.66667 8.6 6.66667 9.33333C6.66667 10.0667 6.06667 10.6667 5.33333 10.6667ZM3.33333 4.66667V3.33333C3.33333 2.22667 4.22667 1.33333 5.33333 1.33333C6.44 1.33333 7.33333 2.22667 7.33333 3.33333V4.66667H3.33333Z"
      fill="currentColor"
      />
      </svg>
      </div>
      </a> -->

    <transition name="modal">
      <module-popup
        v-if="isPopupVisible"
        :model="selectedModule"
        :text="popupText"
        :title="popupTitle"
        :has-request-button="hasButton"
        has-video
        :align-center="false"
        :title-small="false"
        @close="close"
        @submit="sendRequest"
      />
    </transition>

    <transition name="fade">
      <modal-dialog
        :show-custom-buttons="false"
        :open="isConfirmationEnabled"
        class="modules-confirm-modal"
        type="success"
        :text-body="$tr('vacancy.modules.test.success')"
        @close="toggleModalConfirmation(true)"
      >
        <template slot="buttons">
          <div class="buttons-group buttons-group--modal">
            <vbutton class="button-ok" label="common.ok" @click="toggleModalConfirmation(false)" />
          </div>
        </template>
      </modal-dialog>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Axios from 'axios';
import modulePopup from '@/routes_new/inner/vacancy/basic/components/modulePopup.vue';
import modalDialog from '@/components/modals/ModalDialog.vue';
import VcvBillingLock from '@/routes_new/inner/billing/VcvBillingLock';

const onlineInterviewModule = 'online-interview';

export default {
  name: 'HeaderNavigation',

  components: {
    modulePopup,
    modalDialog,
    VcvBillingLock
  },

  data() {
    return {
      onlineInterviewEnabled: false,
      selectedModule: {
        id: onlineInterviewModule
      },

      onlineInterviewModule: onlineInterviewModule,
      isConfirmationEnabled: false,
      isPopupVisible: false,
      hasButton: true
    };
  },

  computed: {
    ...mapGetters('company_new', ['isFeatureDisabledByTariff']),

    online_interview() {
      return this.$route.name === 'online-inner';
    },

    popupTitle() {
      return this.$tr(`vacancy.modules.${this.onlineInterviewModule}.title`);
    },

    popupText() {
      return this.$tr(`vacancy.modules.${this.onlineInterviewModule}.text`);
    }
  },

  created() {
    Axios.get('/1.0/company-module').then(response => {
      const moduleIndex = response.data.data
        .map(item => {
          return item.id;
        })
        .indexOf(onlineInterviewModule);

      if (moduleIndex !== -1) {
        var module = response.data.data[moduleIndex];
        this.onlineInterviewEnabled = module.is_enabled;
      }
    });
  },

  methods: {
    showPopup(model, hasButton = true) {
      this.hasButton = hasButton;
      this.togglePopupVisible(true);
    },

    togglePopupVisible(val) {
      this.isPopupVisible = val;
    },

    toggleModalConfirmation(val) {
      this.isConfirmationEnabled = val;
    },

    goToOnlineInterview() {
      this.$router.push({ path: '/online-interview' });
    },

    close() {
      this.togglePopupVisible(false);
    },

    sendRequest() {
      this.$store
        .dispatch('companyModules/requestModulePayment', { id: this.onlineInterviewModule })
        .then(() => {
          this.togglePopupVisible(false);
          this.toggleModalConfirmation(true);
        })
        .catch(e => {
          this.$noty.error(e.message + '.');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';
@import '@/styles/variables.scss';
@import '@/styles/fonts.scss';

.header-navigation {
  display: flex;
  align-self: center;
  justify-content: flex-start;
  list-style: none;
  padding: 0;
  margin: auto 30px;

  &__item {
    display: flex;
    margin: 0 8px;
  }

  a {
    display: flex;
    text-align: center;
    align-items: center;
    position: relative;

    span {
      @include mixin-text-header;
      border-bottom: 3px solid $white-color;
      padding: 23px 2px 0 2px;
      height: 64px;
      display: block;
      white-space: nowrap;
      line-height: 1.5;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: $green-hover;
        transition: color 0.3s;
      }

      &.active {
        color: $green-active;
        transition: color 0.3s;
      }
    }

    svg {
      color: $main-dark;
      transition: color 0.3s;
    }

    &:hover {
      svg {
        color: $green;
        transition: color 0.3s;
      }
    }

    &.active {
      span {
        color: $green;
        border-bottom-color: $green;
        transition: all 0.3s;
      }
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}

.main-nav ul li:not(:last-child) {
  margin-right: 20px;
}

@media (max-width: 1000px) {
  .main-nav {
    display: none;
  }
}
</style>
